if (!customElements.get('gf-purchase-tools')) {
  customElements.define('gf-purchase-tools', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('product-info') || this.closest('.product__info-container');
      if (!this.root) return;
      this.onChange = event => {
        if (event.target.closest('variant-selects')) this.update();
      };
      this.root.addEventListener('change', this.onChange);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, event => {
          if (String(event.data?.sectionId) === String(this.root.dataset.section)) this.update();
        });
      }
      this.update();
    }
    optionKey(name) {
      const key = String(name || '').toLowerCase().trim();
      if (['model', 'phone model', 'device'].includes(key)) return 'model';
      if (['case', 'case type'].includes(key)) return 'case';
      return key;
    }
    selection() {
      const selected = new Map();
      this.root.querySelectorAll('variant-selects select').forEach(select => {
        const name = select.name.match(/^options\[(.*)\]$/)?.[1] || select.dataset.optionName;
        if (name) selected.set(this.optionKey(name), select.value);
      });
      this.root.querySelectorAll('variant-selects input:checked').forEach(input => {
        const name = input.dataset.optionName || input.name.replace(/-\d+$/, '');
        if (name) selected.set(this.optionKey(name), input.value);
      });
      return selected;
    }
    update() {
      const selected = this.selection();
      const model = String(selected.get('model') || '').toLowerCase();
      this.root.querySelectorAll('[data-gf-family-label]').forEach(label => {
        const family = label.dataset.family === 'auto' ? (model.includes('pixel') ? 'pixel' : model.includes('iphone') ? 'iphone' : /samsung|galaxy/.test(model) ? 'samsung' : '') : label.dataset.family;
        const text = label.dataset[family] || '';
        if (text && label.textContent !== text) label.textContent = text;
      });
      this.root.querySelectorAll('[data-gf-brand]').forEach(brand => {
        const family = brand.dataset.family === 'auto' ? (model.includes('pixel') ? 'pixel' : model.includes('iphone') ? 'iphone' : /samsung|galaxy/.test(model) ? 'samsung' : '') : brand.dataset.family;
        const label = {pixel: 'Google', iphone: 'Apple', samsung: 'Samsung'}[family] || '';
        if (brand.textContent !== label) brand.textContent = label;
        brand.hidden = !label;
      });
      this.root.querySelectorAll('[data-gf-art-link]').forEach(link => {
        try {
          const names = JSON.parse(link.dataset.optionNames || '[]');
          const variants = JSON.parse(link.querySelector('[data-gf-art-variants]')?.textContent || '[]');
          const shared = names.map((name, index) => [this.optionKey(name), index]).filter(([key]) => selected.has(key));
          const match = variants.find(variant => variant.available && shared.every(([key, index]) => String(variant.options[index]).toLowerCase().trim() === String(selected.get(key)).toLowerCase().trim()));
          const requiresModel = selected.has('model');
          const hasTargetModel = names.some(name => this.optionKey(name) === 'model');
          const unavailable = !match || requiresModel && !hasTargetModel;
          link.hidden = unavailable;
          if (unavailable) {
            link.removeAttribute('href');
            link.setAttribute('aria-disabled', 'true');
          } else {
            const url = new URL(link.dataset.baseUrl, window.location.origin);
            url.searchParams.set('variant', match.id);
            link.href = url.pathname + url.search;
            link.removeAttribute('aria-disabled');
          }
        } catch {
          link.hidden = true;
          link.removeAttribute('href');
        }
      });
      this.root.querySelectorAll('gf-artwork-picker').forEach(picker => picker.refresh?.(selected));
    }
    disconnectedCallback() {
      this.root?.removeEventListener('change', this.onChange);
      this.unsubscribe?.();
    }
  });
}
if (!customElements.get('gf-accessory-form')) {
  customElements.define('gf-accessory-form', class extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.button = this.querySelector('button[type="submit"]');
      this.select = this.querySelector('select[name="id"]');
      this.error = this.querySelector('[role="alert"]');
      this.status = this.querySelector('[role="status"]');
      if (!this.form || !this.button) return;
      this.onChange = () => {
        const option = this.select?.selectedOptions[0];
        if (!option) return;
        const price = this.closest('.gf-pairs__row')?.querySelector('[data-gf-accessory-price]');
        if (price) {
          const current = price.querySelector('[data-accessory-current]');
          const compare = price.querySelector('[data-accessory-compare]');
          if (current) current.textContent = option.dataset.price || '';
          else price.textContent = option.dataset.price || '';
          if (compare) { compare.textContent = option.dataset.comparePrice || ''; compare.hidden = !option.dataset.comparePrice; }
        }
        this.button.disabled = this.busy || option.disabled || option.dataset.available === 'false';
      };
      this.onSubmit = event => this.submit(event);
      this.form.addEventListener('submit', this.onSubmit);
      this.select?.addEventListener('change', this.onChange);
      this.onChange();
    }
    async submit(event) {
      event.preventDefault();
      event.stopPropagation();
      if (this.busy || this.button.disabled) return;
      const data = new FormData(this.form);
      const id = data.get('id');
      if (!id) return;
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const cartSections = cart?.getSectionsToRender?.().map(section => section.id) || [];
      this.busy = true;
      this.button.disabled = true;
      this.setAttribute('aria-busy', 'true');
      if (this.error) this.error.hidden = true;
      if (this.status) this.status.textContent = '';
      try {
        const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json', Accept: 'application/json'},
          body: JSON.stringify({items: [{id, quantity: 1}], sections: cartSections, sections_url: window.location.pathname})
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : this.dataset.errorLabel);
        if (this.status) this.status.textContent = this.dataset.addedLabel || '';
        if (cart) {
          cart.setActiveElement?.(this.button);
          cart.classList.remove('is-empty');
          try {
            cart.renderContents({...result, ...(result.items?.[0] || {}), sections: result.sections});
          } catch {
            window.location.assign(window.routes?.cart_url || '/cart');
          }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            Promise.resolve(publish(PUB_SUB_EVENTS.cartUpdate, {source: 'gf-accessory', productVariantId: id, cartData: result})).catch(() => {});
          }
        } else window.location.assign(window.routes?.cart_url || '/cart');
      } catch (error) {
        if (this.error) {
          this.error.textContent = error.message || this.dataset.errorLabel;
          this.error.hidden = false;
        }
      } finally {
        this.busy = false;
        this.button.disabled = this.select?.selectedOptions[0]?.dataset.available === 'false';
        this.removeAttribute('aria-busy');
      }
    }
    disconnectedCallback() {
      this.form?.removeEventListener('submit', this.onSubmit);
      this.select?.removeEventListener('change', this.onChange);
    }
  });
}
